<template>
  <div class="mod-config">
    <div style="border-radius: 30px">
      <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-row>
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input size="mini" v-model="venderCode" style="width: 150px " placeholder="供应商代码" clearable @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="venderName">
            <el-input size="mini" v-model="venderName" style="width: 150px " placeholder="供应商名称" clearable @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="applyStatus">
            <el-select v-model="applyStatus" clearable placeholder="请选择" @change="getDataList">
              <el-option v-for="item in options1" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div v-loading="dataListLoading">
      <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                border :header-cell-style="{background:'#f5f5f5'}">

        <el-table-column header-align="center" label="序号" align="center" width="55">
          <template slot-scope="scope">
            {{ scope.row.rowid }}
          </template>
        </el-table-column>

        <el-table-column prop="applyformNum" header-align="center" align="right" width="120" label="审批单号">
          <template slot-scope="scope">
            {{ scope.row.applyformNum }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="supplierLevel" header-align="center" align="center" label="等级" min-width="130">
            <template slot-scope="scope">
                <span v-if="scope.row.supplierLevel == '0'">潜在</span>
                <span v-if="scope.row.supplierLevel == '1'">合格</span>
                <span v-if="scope.row.supplierLevel == '2'">一次性</span>
            </template>
        </el-table-column> -->
        <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.venderCode }}
          </template>
        </el-table-column>
        <el-table-column prop="enterpriseName" header-align="center" align="left" label="供应商名称" min-width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="handleCheck(scope.row)">
              {{ scope.row.enterpriseName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="applyStatus" header-align="center" align="center" width="120" label="状态">
          <template slot-scope="scope">
            <span style="color:#67C23A" v-for="(item, index) in scope.row.applyStatus.split(',')" :key="index" size="mini" type="success">{{item}}<br></span>
          </template>
        </el-table-column>
        <el-table-column
            prop="pic"
            header-align="center"
            align="center"
            width="120"
            label="当前流程图示">
          <template slot-scope="scope">
            <el-link :disabled="scope.row.applyStatus === '流程结束'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId, scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
          </template>
        </el-table-column>

        <el-table-column prop="createByName" header-align="center" align="left" width="120" label="申请人">
          <template slot-scope="scope">
            {{ scope.row.createByName }}
          </template>
        </el-table-column>

        <el-table-column prop="createTimeStr" header-align="center" align="right" width="200" label="申请日期" >
          <template slot-scope="scope">
            {{ scope.row.createTimeStr }}
          </template>
        </el-table-column>

        <el-table-column prop="disReason" header-align="center" align="center" label="审批历史">
          <template slot-scope="scope">
            <el-button @click="doHistory(scope.row)">查看</el-button>
          </template>
        </el-table-column>

        <el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.taskActions" :key="index">
              <!-- <el-button icon="el-icon-s-check" v-if="!item.flowRuleType" size="small" type="text"
                         @click="execFinish(scope.row.id, item.taskId, scope.row.targetId)">
                  批准
              </el-button> -->
              <div v-if="item.flowRuleType && item.flowRuleType === 'action'">
                <el-button icon="el-icon-circle-check" type="text" size="small"
                           @click="execApprove(scope.row.id, item.taskId, item.flowRuleType, item.normalValue, scope.row.supplierBasicId, scope.row.venderInviteFid)">通过
                </el-button>
                <el-button icon="el-icon-circle-close" type="text" size="small" style="color:#F56C6C"
                           @click="execApprove2(scope.row.id, item.taskId, item.flowRuleType, item.reverseValue, scope.row.supplierBasicId, scope.row.venderInviteFid)">驳回
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>



    <el-dialog
        :visible.sync="showViewer"
        width="80%"
        title="流程图">
      <el-image :src="diagramUrl" style="margin-bottom: 120px;">
      </el-image>
    </el-dialog>

    <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
      <div class="workflow-container">
        <div class="workflow-steps">
          <!-- 节点 1: 提交供应商变更申请 -->
          <div class="step" :class="getStepClass(1, currentWorkflowData)">
            <div class="step-circle">1</div>
            <div class="step-label">提交供应商变更申请</div>
            <div class="step-status">{{ getStepStatusText(1, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 1→2 -->
          <div class="step-line" :class="getLineClass(1, 2, currentWorkflowData)"></div>

          <!-- 节点 2: 供应商管理员审批 -->
          <div class="step" :class="getStepClass(2, currentWorkflowData)">
            <div class="step-circle">2</div>
            <div class="step-label">供应商管理员审批</div>
            <div class="step-status">{{ getStepStatusText(2, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 2→3 -->
          <div class="step-line" :class="getLineClass(2, 3, currentWorkflowData)"></div>

          <!-- 节点 3: 采购部长审批 -->
          <div class="step" :class="getStepClass(3, currentWorkflowData)">
            <div class="step-circle">3</div>
            <div class="step-label">采购部长审批</div>
            <div class="step-status">{{ getStepStatusText(3, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 3→4 (根据条件显示) -->
          <div class="step-line" :class="getLineClass(3, 4, currentWorkflowData)" v-if="!currentWorkflowData || currentWorkflowData.subcompanyId !== '170'"></div>

          <!-- 节点 4: 采购总监审批 (根据条件显示) -->
          <div class="step" :class="getStepClass(4, currentWorkflowData)" v-if="!currentWorkflowData || currentWorkflowData.subcompanyId !== '170'">
            <div class="step-circle">4</div>
            <div class="step-label">采购总监审批</div>
            <div class="step-status">{{ getStepStatusText(4, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 3或4→5 -->
          <div class="step-line" :class="getLineClass(currentWorkflowData && currentWorkflowData.subcompanyId === '170' ? 3 : 4, 5, currentWorkflowData)"></div>

          <!-- 节点 5: 流程结束 -->
          <div class="step" :class="getStepClass(5, currentWorkflowData)">
            <div class="step-circle">5</div>
            <div class="step-label">流程结束</div>
            <div class="step-status">{{ getStepStatusText(5, currentWorkflowData) }}</div>
          </div>
        </div>

        <!-- 当前状态说明 -->
        <div class="current-status">
          <h4>当前状态：{{ getCurrentStatusText(currentWorkflowData) }}</h4>
          <p>{{ getCurrentStatusDesc(currentWorkflowData) }}</p>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="'提示'" width="30%" :close-on-click-modal="false" :visible.sync="unQuoteReasonFlag">
      <el-form label-width="0px" :rules="dataRule" :model="dataForm2" ref="dataForm2">
        <el-form-item prop="unQuoteReason">
          <el-input type="textarea" :rows="2" placeholder="请输入驳回原因" v-model="dataForm2.unQuoteReason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unQuoteReasonFlag = false">取 消</el-button>
        <el-button type="primary" @click="UpdateBybohui()">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
      <div v-for="str in historyList" :key="str">
        <el-descriptions :title="str.executeTime">
          <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
          <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
      </div>
    </el-drawer>

    <!--点击供应商名称查看-->
    <el-dialog title="查看变更信息" :visible.sync="checkdialogVisible" width="1200px">
      <el-table-editabled :model="dataList1">
        <el-table border :data="dataList1">
          <el-table-column label="序号" align="center" header-align="center" width="70">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="fieldName" label="项目" align="center" header-align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.fieldName" disabled></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="venderOldInfo" label="原信息" align="center" header-align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.fieldName == '企业性质'" style="width: 100%" v-model="scope.row.venderOldInfo" disabled>
                <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-select v-else-if="scope.row.fieldName == '供应商关系'" style="width: 100%" v-model="scope.row.venderOldInfo" disabled>
                <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-input v-else v-model="scope.row.venderOldInfo" disabled></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="venderNewInfo" label="新信息" align="center" header-align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.fieldName == '企业性质'" style="width: 100%" v-model="scope.row.venderNewInfo" disabled>
                <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-select v-else-if="scope.row.fieldName == '供应商关系'" style="width: 100%" v-model="scope.row.venderNewInfo" disabled>
                <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-input v-else v-model="scope.row.venderNewInfo" disabled></el-input>
            </template>
          </el-table-column>
        </el-table>
        <hr />
        <el-table border :data="dataList4">
          <el-table-column prop="originalName" header-align="center" align="left" label="文件名称">
          </el-table-column>

          <!-- <el-table-column
          prop="fileDesc"
          header-align="center"
          align="left"
          label="文件描述">
      </el-table-column> -->

          <el-table-column prop="fileSize" header-align="center" align="right" label="文件大小">
          </el-table-column>

          <el-table-column prop="fileDir" header-align="center" align="center" width="120" label="查看附件">
            <template slot-scope="scope">
              <el-button v-if="scope.row.fileType === 'application/pdf'" icon="el-icon-view" type="text" @click="viewHandle(scope.row)">查看</el-button>
              <el-button v-else icon="el-icon-view" type="text" @click="viewHandle(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-table-editabled>
    </el-dialog>
    <pdf-view v-if="pdfPreviewVisible" ref="pdfPreview"></pdf-view>
  </div>
</template>
<script>
import {selectChangeApprovePage,execTask4} from '@/controller/supplier'
import {selectChangeInfoList} from '@/controller/portal'
import { listAllStatus,getProcessDiagramCurrent,listCommentHistory} from '@/controller/workflow'
import {
  getFileList,
  uploadFile,
  getUrl,
  deleteFileById
} from '@/controller/sys'
import PdfView from '@/components/pdf-view'

export default {
  data() {
    return {
      FILE_BIZ_TYPE:4,
      FILE_SUB_TYPE:9,
      pdfPreviewVisible: false,
      checkdialogVisible: false,
      dataForm: {
        key: ''
      },
      dataForm2: {
        unQuoteReason: '',
        id : '',
        taskId : '',
        flowType : '',
        val : '',
        supplierBasicId: '',
        venderInviteId: '',
      },
      applyStatus: '',
      showViewer: false,
      diagramUrl: '',
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      venderName: '',
      style: {
        leftStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
          overflow: "auto"
        },
        rightStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
        },
        gridStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
        }
      },
      dataRule: {
        remarks: [
          { required: true, message: '请填写驳回原因', trigger: 'blur' }
        ],
      },
      unQuoteReasonFlag: false,
      venderCode : '',
      // 通过或驳回表单
      form: {
        remarks: '',
        id: '',
        taskId:'',
        flowType:'',
        val:''
      },
      // 审批历史
      drawer: false,
      // 审批列表
      historyList:[],
      // 供应商变更查看
      dataList1:[],
      // 供应商变更文件查看
      dataList4:[],
      options1:[],
      // 企业性质
      options3: [{
        label: '私有控股',
        value: '0'
      },
        {
          label: '国有（集体）控股',
          value: '1'
        },
        {
          label: '中外合资企业',
          value: '2'
        },
        {
          label: '外商独资企业',
          value: '3'
        }
      ],
      options4: [{
        label: '公司所属供应商',
        value: '0'
      },
        {
          label: '股东供应商',
          value: '1'
        },
        {
          label: '一般供应商',
          value: '2'
        }
      ],
      // 新增：工作流相关
      showWorkflowDialog: false,  // 控制工作流对话框显示
      currentWorkflowData: null, // 当前行数据
      statusPriority: {
        '提交供应商变更申请': 1,
        '供应商管理员审批': 2,
        '采购部长审批': 3,
        '采购总监审批': 4,
        '流程结束': 5
      }
    }
  },

  components: {
    PdfView
  },

  activated() {
    if (this.$route.query && this.$route.query.state && this.$route.query.state.length > 0) {
      this.applyStatus = this.$route.query.state
    }
    this.getDataList()
    this.getAllStatus()
  },

  methods: {

    dateFormat: function (row, column) {
      var date = row[column.property]
      if (!date) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },

    viewDiagram(id, row) {
      // 如果能找到对应行数据，则使用新的工作流对话框
      if (row) {
        this.currentWorkflowData = row;
        this.showWorkflowDialog = true;
      } else {
        // 否则使用原来的流程图查看功能
        getProcessDiagramCurrent({id: id}).then(data => {
          this.diagramUrl = data.body;
          this.showViewer = true;
        });
      }
    },

    getStepClass(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      return {
        'step-completed': status === 'completed',
        'step-current': status === 'current',
        'step-pending': status === 'pending'
      };
    },

    // 获取连线样式类
    getLineClass(fromStep, toStep, rowData) {
      const fromStatus = this.getStepStatus(fromStep, rowData);
      const toStatus = this.getStepStatus(toStep, rowData);

      // 如果前一个节点已完成，连线显示为完成状态
      if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
        return 'line-completed';
      }
      // 如果前一个节点是进行中，且后一个节点是当前节点
      else if (fromStatus === 'current' && toStatus === 'current') {
        return 'line-active';
      }
      return 'line-pending';
    },

    // 获取步骤状态
    getStepStatus(step, rowData) {
      // 特殊处理：如果subcompanyId为'170'，则跳过第4步（采购总监审批）
      if (rowData && rowData.subcompanyId === '170' && step === 4) {
        return 'skipped';
      }

      // 如果subcompanyId为'170'，第5步实际上是第4步的后续
      let adjustedStep = step;
      if (rowData && rowData.subcompanyId === '170' && step > 3) {
        adjustedStep = step - 1;
      }

      const status = rowData ? rowData.applyStatus : '';
      const priority = this.statusPriority[status] || 0;

      // 定义各状态的预期流程
      let statusSequence;
      if (rowData && rowData.subcompanyId === '170') {
        // subcompanyId为'170'时不包含采购总监审批
        statusSequence = [
          { step: 1, name: '提交供应商变更申请', requiredStatus: '提交供应商变更申请' },
          { step: 2, name: '供应商管理员审批', requiredStatus: '供应商管理员审批' },
          { step: 3, name: '采购部长审批', requiredStatus: '采购部长审批' },
          { step: 4, name: '流程结束', requiredStatus: '流程结束' }
        ];
      } else {
        // 正常流程包含所有步骤
        statusSequence = [
          { step: 1, name: '提交供应商变更申请', requiredStatus: '提交供应商变更申请' },
          { step: 2, name: '供应商管理员审批', requiredStatus: '供应商管理员审批' },
          { step: 3, name: '采购部长审批', requiredStatus: '采购部长审批' },
          { step: 4, name: '采购总监审批', requiredStatus: '采购总监审批' },
          { step: 5, name: '流程结束', requiredStatus: '流程结束' }
        ];
      }

      // 找到当前步骤对应的配置
      const currentStepConfig = statusSequence.find(s => s.step === adjustedStep);
      if (!currentStepConfig) return 'pending';

      // 如果当前状态等于该步骤的状态，则为进行中
      if (status === currentStepConfig.requiredStatus) {
        return 'current';
      }

      // 如果当前状态优先级高于该步骤的状态，则为已完成
      if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
        return 'completed';
      }

      // 否则为待处理
      return 'pending';
    },

    // 获取步骤状态文本
    getStepStatusText(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      switch (status) {
        case 'completed':
          return '✓ 已完成';
        case 'current':
          return '▶ 进行中';
        case 'pending':
          return '○ 待处理';
        case 'skipped':
          return '— 已跳过';
        default:
          return '';
      }
    },

    // 获取当前状态文本
    getCurrentStatusText(rowData) {
      const statusMap = {
        '提交供应商变更申请': '提交供应商变更申请',
        '供应商管理员审批': '等待供应商管理员审批',
        '采购部长审批': '等待采购部长审批',
        '采购总监审批': '等待采购总监审批',
        '流程结束': '流程已完成'
      };

      if (rowData && rowData.applyStatus) {
        if (rowData.subcompanyId === '170' && rowData.applyStatus === '流程结束') {
          return '流程已完成（无采购总监审批）';
        }
        return statusMap[rowData.applyStatus] || rowData.applyStatus;
      }

      return '';
    },

    // 获取当前状态描述
    getCurrentStatusDesc(rowData) {
      const descMap = {
        '提交供应商变更申请': '正在提交供应商变更申请',
        '供应商管理员审批': '供应商管理员正在审核变更申请',
        '采购部长审批': '采购部长正在审核变更申请',
        '采购总监审批': '采购总监正在审核变更申请',
        '流程结束': '所有审批环节已完成，供应商变更申请通过'
      };

      if (rowData && rowData.applyStatus) {
        if (rowData.subcompanyId === '170' && rowData.applyStatus === '流程结束') {
          return '所有审批环节已完成，供应商变更申请通过（已跳过采购总监审批）';
        }
        return descMap[rowData.applyStatus] || '暂无状态描述';
      }

      return '暂无状态描述';
    },

    // 显示文件列表
    viewThawFile(row){

    },

    // 查询状态列表
    getAllStatus(){
      listAllStatus({
        'processDefKey': 'SCI0'
      }).then(data => {
        if (data && data.code === '00') {
          this.options1 = data.body.map(str => {
            return {'value': str, 'label': str}
          })
        }
      })
    },

    // 查询按钮
    queryHandle() {
      this.pageIndex = 1
      this.getDataList()
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      selectChangeApprovePage({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'venderCode': this.venderCode,
        'venderName': this.venderName,
        'key': this.dataForm.key,
        'applyStatus': this.applyStatus,
        'approvedBy': this.approvedBy,
        'approveLevel': 0,
        'applyformType': '11',
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          //  this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },

    //多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },

    //单选
    radioChange(row) {
      this.dataListSelections = row;
    },

    //已完成未完成筛选
    handleCheckAllChange() {
      this.pageIndex = 1
      this.getDataList()
    },
    rowClassName({
                   row,
                   rowIndex
                 }) {
      //把每一行的索引放进row.id
      row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
    },

    //查看
    venderUserDetail(row) {

    },

    //关闭弹框的事件
    closeDialog() {
      this.getDataList()
    },

    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },

    // 代码审批通过
    execApprove(id, taskId, flowType, val, supplierBasicId, venderInviteId){
      this.$confirm(`确定进行通过操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataListLoading = true
        debugger
        execTask4({
          'id': id,
          'taskId': taskId,
          'paramKey': flowType,
          'paramVal': val,
          'targetId':supplierBasicId,
          'venderInviteId': venderInviteId
        }).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
          }
        })

      })
    },

    //驳回
    execApprove2(id, taskId, flowType, val, supplierBasicId, venderInviteId) {
      this.dataForm2.unQuoteReason = ''
      this.dataForm2.id = id,
          this.dataForm2.taskId = taskId,
          this.dataForm2.flowType = flowType,
          this.dataForm2.val = val,
          this.dataForm2.supplierBasicId = supplierBasicId,
          this.dataForm2.venderInviteId = venderInviteId,
          this.unQuoteReasonFlag = true

      console.log('驳回',this.dataForm)
    },

    // 驳回
    UpdateBybohui(){

      this.$confirm(`确定进行驳回操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let params = {
          'id': this.dataForm2.id,
          'taskId': this.dataForm2.taskId,
          'paramKey': this.dataForm2.flowType,
          'paramVal': this.dataForm2.val,
          'targetId': this.dataForm2.supplierBasicId,
          'unQuoteReason' : this.dataForm2.unQuoteReason,
          'venderInviteId': this.dataForm2.venderInviteId,
        }
        //console.log(params)

        execTask4(params).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
            this.$message({
              message: '驳回成功',
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
                this.unQuoteReasonFlag = false
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })

      })

    },

    // 审批历史
    doHistory(row){
      this.historyList = []
      listCommentHistory({'workflowId' : row.workflowId}).then(data => {
        if (data && data.code === '00') {
          this.historyList = data.body
        } else {
          this.$message.error(data.msg)
        }
      })
      this.drawer = true
    },

    //点击供应商名称查看信息
    handleCheck(row) {
      debugger
      this.selectFileList(row.id)
      this.checkdialogVisible = true
      selectChangeInfoList({
        'applyFormFid': row.id,
        'supplierBusinessId': row.targetId,
        'edit':'0'
      }).then(data => {
        if (data && data.code === '00') {
          console.log(data, 'data')
          this.dataList1 = data.body
        }else{

        }
      }).catch(() => {})
    },

    // 查询文件列表
    selectFileList(id) {
      debugger
      getFileList({
        'id': id,
        'bizType': this.FILE_BIZ_TYPE
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList4 = data.body
        } else {
          this.dataList4 = []
        }
      })
    },

    viewHandle(row) {
      console.log(row, 'row')

      getUrl({
        'fileId': row.id
      }).then(data => {
        if (data && data.code === '00' && data.body) {
          // location.href=data.body;
          if (row.fileType === 'application/pdf') {
            this.previewPdf(data.body)
          } else {
            this.download(data.body, row.originalName)
          }
        } else {
          this.tableData = []
        }
      })
    },

    previewPdf(pdfUrl) {
      this.pdfPreviewVisible = true
      this.$nextTick(() => {
        //此处参数传入pdf文件的地址
        this.$refs.pdfPreview.init(pdfUrl)
      })
    },

    download(url, filename) {
      const _this = this
      this.getBlob(url, function (blob) {
        _this.saveAs(blob, filename);
      });
    },

    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },

    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },

  }
}
</script>

<style scoped>
/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 100px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 12px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  width: 100px;
  word-wrap: break-word;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

.step-skipped .step-circle {
  background: #909399;
  color: white;
  border-color: #909399;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
</style>
